import { ReactElement } from 'react'

import { T } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'

export const EmptyState = ({ text }: { text?: ReactElement }) => (
  <Card>
    <div className="py-12 flex flex-col justify-center">
      <h3 className="text-heading-sm font-medium text-center">
        {text || (
          <T
            defaultMessage="All is clear! {cheers_emoji}"
            id="Moderation.EmptyState"
            values={{
              cheers_emoji: '🎉',
            }}
          />
        )}
      </h3>
    </div>
  </Card>
)
